import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, Transition as _Transition, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import { Suspense, Transition } from "vue";
import { RouterView } from "vue-router";
import Loading from "./views/Loading.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterView), null, {
    default: _withCtx(({ Component }) => [
      Component
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "custom-classes",
            "enter-active-class": "animate__animated animate__fadeIn animate__faster",
            "leave-active-class": "animate__animated animate__fadeOut animate__faster"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_Suspense, null, {
                fallback: _withCtx(() => [
                  _createVNode(Loading)
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                _: 2
              }, 1024))
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})